import dayjs from 'dayjs';

export function formatDateTransform(item, dateKeys) {
  const formatDate = (date) => (date ? dayjs(date).format("YYYY-MM-DD") : null);
  const newItem = Object.assign({}, item);
  dateKeys.forEach((key) => {
    newItem[key] = formatDate(item[key]);
  });
  return newItem;
}
